function s(s,e){if(1===e)return s;const c=s.trim();return["s","x","z"].includes(c.slice(-1))||["sh","ch"].includes(c.slice(-2))?`${c}es`:`${c}s`}export{s as pluralise};
//# sourceMappingURL=pluralise.js.map
